import React from 'react';
import Axios from 'axios';
import { ConnectedUserContext } from '../../connectedUser-context';
import TeamsDropdown from '../../shared/TeamsDropdown';
import HandicapTypeSelect from '../../shared/Tools/HandicapTypeSelect';
import CumulativeTypeDropdown from '../../shared/CumulativeTypeDropdown';

import * as myConstClass from '../../shared/constants/constants';
import { HANDICAPTYPE } from "../../shared/constants/constants";


class SeasonAdmin_gen extends React.Component {

	static contextType = ConnectedUserContext;

  constructor(props) {
		super(props);

		this.state = {
			season: this.props.season,
			teams: [],
			ratingTypes: [],
			scoresheetFormatsAll: [],
			selectedScoresheetFormatId: "0",
			scoresheetFormatsTable: [],
			membershipcardSeasons: [],
			newTeamName: '',
			msgSaved: '',

			// preventing that handicapType/Max affect the select in scheduleMatchModal
      draftHandicapType: props.season.handicapType || HANDICAPTYPE.NONE,
      draftHandicapMax: props.season.handicapMax || null,
      saving: false			
		};
	
		this.loadData = this.loadData.bind(this);
		this.createTeamsTable = this.createTeamsTable.bind(this);
		this.createTeamRow = this.createTeamRow.bind(this);
		this.handleNewTeamNameChange = this.handleNewTeamNameChange.bind(this);
		this.handleSeasonNameChange = this.handleSeasonNameChange.bind(this);
		this.handleSeasonsGroupingChange = this.handleSeasonsGroupingChange.bind(this);
		this.handleSeasonSpecialChange = this.handleSeasonSpecialChange.bind(this);
		this.handleStatusChange = this.handleStatusChange.bind(this);
		this.handleLeagueTypeChange = this.handleLeagueTypeChange.bind(this);
		this.handleResultsTypeChange = this.handleResultsTypeChange.bind(this);
		this.handleNbMatchEqChange = this.handleNbMatchEqChange.bind(this);
		this.handlePlayerCostChange = this.handlePlayerCostChange.bind(this);
		this.handleMembershipcardSeasonChange = this.handleMembershipcardSeasonChange.bind(this);
		this.handicapTypeChange = this.handicapTypeChange.bind(this);
		this.handleHandicapMaxChange = this.handleHandicapMaxChange.bind(this);
		this.handleDateStartChange = this.handleDateStartChange.bind(this);
		this.handleDateEndChange = this.handleDateEndChange.bind(this);
		this.handleStandingTypeTeamsChange = this.handleStandingTypeTeamsChange.bind(this);
		this.handleStandingTypePlayersChange = this.handleStandingTypePlayersChange.bind(this);
		this.handleRatingTypeChange = this.handleRatingTypeChange.bind(this);
		this.handleLeagueParamChange = this.handleLeagueParamChange.bind(this);
		this.handleFormatTeamIndivChange = this.handleFormatTeamIndivChange.bind(this);
		this.handleFormatRoundPtsChange = this.handleFormatRoundPtsChange.bind(this);
		this.handleFormatMatchPointChange = this.handleFormatMatchPointChange.bind(this);
		this.handleFormatMatchTypeChange = this.handleFormatMatchTypeChange.bind(this);
		this.handleMontQvneaTypeChange = this.handleMontQvneaTypeChange.bind(this);
		this.handleMontQvneaYearsChange = this.handleMontQvneaYearsChange.bind(this);
		this.handleMontQvneaMetersChange = this.handleMontQvneaMetersChange.bind(this);
		this.handleHideRatings = this.handleHideRatings.bind(this);
		this.handleQvneaBooksNewEntries = this.handleQvneaBooksNewEntries.bind(this);
		this.handleLiveScoresheetsStatusChange = this.handleLiveScoresheetsStatusChange.bind(this);
		this.handleLiveScoresheetsValidationChange = this.handleLiveScoresheetsValidationChange.bind(this);
		this.handleAddNewTeam = this.handleAddNewTeam.bind(this);
		this.handleRemoveTeam = this.handleRemoveTeam.bind(this);
		//this.handleSaveClick = this.handleSaveClick.bind(this);
		this.handleCumulClick = this.handleCumulClick.bind(this);
		this.handleCreateRateSysClick = this.handleCreateRateSysClick.bind(this);
		this.savedMsgSet = this.savedMsgSet.bind(this);
		this.savedMsgUnset = this.savedMsgUnset.bind(this);

		this.createFormatRow = this.createFormatRow.bind(this);
		this.handleScoresheetFormatSelectChange = this.handleScoresheetFormatSelectChange.bind(this);
		this.handleAddScoresheetFormat = this.handleAddScoresheetFormat.bind(this);
	}

 	componentDidMount() {
		this.loadData(this.props.season);
	}
	
	componentDidUpdate(prevProps) {
		//console.log('SeasonAdminGen: componentDidUpdate: ');
	  if (prevProps.season !== this.props.season) {
	    this.loadData(this.props.season)
	  }
	}

	loadData(season) {
		// Load RatingTypes
		Axios.get('/api/ratingTypes').then(respRatingTypes => {
		Axios.get('/api/seasons/membershipcardSeasons').then(membershipcardSeasons => {
		Axios.get('/api/scoresheets2/scoresheetFormats/all').then(respScoresheetFormatsAll => {

			var scoresheetFormatsAll = respScoresheetFormatsAll.data;		// ok
			
			// season is empty on first renders when refreshing page (due to league change first with no season)
			if (season._id !== undefined) {

			  season.scoresheetFormats = this.seasonScoresheetFormatsPostProcess(scoresheetFormatsAll, season.scoresheetFormats);

	  	  Axios.get('/api/teams/season/' + season._id).then(response => {
					this.refreshScoresheetFormatsTable(scoresheetFormatsAll, season.scoresheetFormats)
					this.setState({
						teams: response.data,
						season: season,
						ratingTypes: respRatingTypes.data,
						scoresheetFormatsAll: scoresheetFormatsAll,
						selectedScoresheetFormatId: "0",
						membershipcardSeasons: membershipcardSeasons.data,

						// preventing that handicapType/Max affect the select in scheduleMatchModal
						draftHandicapType: season.handicapType || HANDICAPTYPE.NONE,
      			draftHandicapMax: season.handicapMax || null,
					});	
				});
  		}
		});	
		});	
		});	
  }

	seasonScoresheetFormatsPostProcess (scoresheetFormatsAll, seasonScoresheetFormats) {

		if (seasonScoresheetFormats.length !== 0) {
			// create index first (more efficient this way)
			const indexTableFormatsAll = {};
			scoresheetFormatsAll.forEach(sfa => {
				indexTableFormatsAll[sfa._id] = sfa;
			});

			// use index
			seasonScoresheetFormats = seasonScoresheetFormats.map(ssf => {
		    const sfa = indexTableFormatsAll[ssf._id];
		    if (sfa) {
	        return {
	          _id: sfa._id,
	          tag: sfa.tag,
	          def: ssf.def
	        };
		    }
			}).filter(Boolean); // Pour éliminer les undefined si certains items n'ont pas de correspondance dans scoresheetFormatsAll

			if (seasonScoresheetFormats.every(item => (item.def === false))) {
				seasonScoresheetFormats[0].def = true;
			}
			seasonScoresheetFormats.sort((a, b) => (a.tag.localeCompare(b.tag)));
			seasonScoresheetFormats.forEach(ssf => delete ssf.tag);
		}

		return seasonScoresheetFormats;
	}  

  refreshScoresheetFormatsTable (scoresheetFormatsAll, seasonScoresheetFormats) {

		// create index first (more efficient this way)
		const indexTableFormatsAll = {};
		scoresheetFormatsAll.forEach(sfa => {
		    indexTableFormatsAll[sfa._id] = sfa;
		});

		// use index
		const scoresheetFormatsTable = seasonScoresheetFormats.map(ssf => {
	    const sfa = indexTableFormatsAll[ssf._id];
	    if (sfa) {
        return {
          _id: sfa._id,
          tag: sfa.tag,
          description_fr: sfa.description_fr,
          description_en: sfa.description_en,
          def: ssf.def
        };
	    }
		}).filter(Boolean); // Pour éliminer les undefined si certains items n'ont pas de correspondance dans scoresheetFormatsAll
  	this.setState({ scoresheetFormatsTable: scoresheetFormatsTable });
  }

  render() {
  	console.log('SeasonAdmin_gen: RENDER');
  	console.log(this.state);

		const { connectedUser } = this.context;
		const { season, ratingTypes, membershipcardSeasons } = this.state;

		// preventing that handicapType/Max affect the select in scheduleMatchModal		
		const { draftHandicapType, draftHandicapMax } = this.state;

	  // ADMIN LEVEL REQUESTED:  03-SEASON
		if (season._id === "0") {
      return (
	      <div className="col-md-9">
          <p>Vous devez d'abord créer une saison pour cette ligue dans l'onglet Ligue</p>
	      </div>
      );

		} else {

			return (
        <div>
        	<div className="row">
        	<div className="col-md-12">
						<h5>Paramètres généraux</h5>
          </div>
          </div>

        	<div className="row row-margin-bottom-10">
        	<div className="col-md-12">

						{ connectedUser.isMasterAdmin ?
        			<p className="no-margin-bottom"><strong>ID: </strong>{season._id}</p> : null}
        		<p><strong>URL tag: </strong>{season.seasonTag}</p>

						<form className="form">
							<div className="row row-margin-bottom-10">
							<div className="col-md-6">
					  		<label htmlFor="idseasonname" className="small labelSmallMarginBottom">Nom de la Saison</label>
					  		<input className="form-control form-control-sm" type="text" id="idseasonname" 
					  			value={season.name || ''} onChange={this.handleSeasonNameChange}/>
              </div>
							<div className="col-md-3">
			  				<label htmlFor="idlgstatus" className="small labelSmallMarginBottom">Statut</label>
					  		<select className="form-control form-control-sm" type="text" id="idlgstatus" 
					  			value={season.status} onChange={this.handleStatusChange}>
								<option>Inactive</option>
								<option>Active</option>
								<option>Archivée</option>
								</select>
              </div>
              </div>

							<div className="row row-margin-bottom-10">
							<div className="col-md-3">
			  				<label htmlFor="idlgtype" className="small labelSmallMarginBottom">Type de ligue</label>
					  		<select className="form-control form-control-sm" type="text" id="idlgtype" value={season.leagueType} onChange={this.handleLeagueTypeChange}>
								<option>{myConstClass.LGTYPE_8B}</option>
								<option>{myConstClass.LGTYPE_9B}</option>
								<option>{myConstClass.LGTYPE_10B}</option>
								</select>
              </div>

							<div className="col-md-3">
			  				<label htmlFor="idrestype" className="small labelSmallMarginBottom">Type de Résultats</label>
					  		<select className="form-control form-control-sm" type="text" id="idrestype" value={season.resultsType} onChange={this.handleResultsTypeChange}>
								<option>{myConstClass.RESTYPE_LEAGUE}</option>
								<option>{myConstClass.RESTYPE_TOURNAMENT}</option>
								</select>
              </div>

							<div className="col-md-3">
					  		<label htmlFor="handtype" className="small labelSmallMarginBottom">Type de Handicap</label>
              	{/*
              	<HandicapTypeSelect specificClass="form-control-sm" id="handtype" 
              		handicapType={season.handicapType || ''} 
              		handicapTypeChange={this.handicapTypeChange}/>
              	*/}
              	<HandicapTypeSelect specificClass="form-control-sm" id="handtype" 
              		handicapType={draftHandicapType || ''} 
              		handicapTypeChange={this.handicapTypeChange} />
              </div>

							<div className="col-md-3">
					  		<label htmlFor="handicapMax" className="small labelSmallMarginBottom">Handicap maximum</label>
              	{/*
              	<input className="form-control form-control-sm" type="number" id="handicapMax" 
              		value={season.handicapMax || 0} onChange={this.handleHandicapMaxChange} /> */}
              	<input className="form-control form-control-sm" type="number" id="handicapMax" 
              		value={draftHandicapMax || 0} onChange={this.handleHandicapMaxChange} />
	            </div>
              </div>

							<div className="row row-margin-bottom-10">
							<div className="col-md-3">
					  		<label htmlFor="dateStart" className="small labelSmallMarginBottom">Date de début</label>
					  		<input className="form-control form-control-sm" type="date" id="dateStart" value={season.dateStart || 0} onChange={this.handleDateStartChange}/>
              </div>

							<div className="col-md-3">
					  		<label htmlFor="dateEnd" className="small labelSmallMarginBottom">Date de fin</label>
					  		<input className="form-control form-control-sm" type="date" id="dateEnd" value={season.dateEnd || 0} onChange={this.handleDateEndChange}/>
              </div>

							<div className="col-md-3">
					  		<label htmlFor="nbMatchEq" className="small labelSmallMarginBottom">Nb de programmes</label>
					  		<input className="form-control form-control-sm" type="number" id="nbMatchEq" value={season.nbMatchEq || 0} onChange={this.handleNbMatchEqChange}/>
              </div>
              </div>

							<div className="row row-margin-bottom-10">
							<div className="col-md-5">
					  		<label htmlFor="defteamtype" className="small labelSmallMarginBottom">Type de classement par défaut (équipes)</label>
              	<CumulativeTypeDropdown specificClass="form-control-sm" id="defteamtype" value={season.standingTypeTeams || ''} dispSubseason={true}
              		cumulTypeChange={this.handleStandingTypeTeamsChange} resType={season.resultsType}></CumulativeTypeDropdown>
              </div>

							<div className="col-md-5">
					  		<label htmlFor="defplayertype" className="small labelSmallMarginBottom">Type de classement par défaut (joueurs)</label>
              	<CumulativeTypeDropdown specificClass="form-control-sm" id="defplayertype" value={season.standingTypePlayers || ''} dispSubseason={true}
              		cumulTypeChange={this.handleStandingTypePlayersChange} resType={season.resultsType}></CumulativeTypeDropdown>
              </div>
              </div>

							<div className="row row-margin-bottom-10">
							<div className="col-md-5">
					  		<label htmlFor="ratingType" className="small labelSmallMarginBottom">Système de cotation</label>
					  		<select className="form-control form-control-sm input-sm" type="text" id="ratingTypeId" 
					  			value={season.ratingTypeId} onChange={this.handleRatingTypeChange}>
					  				<option value='0' key='opt.rt.0'> aucun </option>
					  				{ratingTypes.map(this.optRatingTypes)}
								</select>
              </div>

							<div className="col-md-2">
					  		<label htmlFor="playerCost" className="small labelSmallMarginBottom">Coût par joueur</label>
					  		<input className="form-control form-control-sm" type="number" id="playerCost" value={season.playerCost || 0} onChange={this.handlePlayerCostChange}/>
			        </div>

							<div className="col-md-4">
					  		<label htmlFor="membershipCardSeason" className="small labelSmallMarginBottom">Carte de membre (QVNEA)</label>
					  		<select className="form-control form-control-sm input-sm" type="text" id="membershipCardSeason" 
					  			value={season.membershipcardSeasonId} 
					  			onChange={this.handleMembershipcardSeasonChange}>
					  				<option value='0' key='opt.rt.0'> </option>
					  				{membershipcardSeasons.map((mcs, mcsidx) => (
					  					<option value={mcs._id} key={"opt-mcs-" + mcsidx}> {mcs.name} </option>
					  				))}
								</select>
              </div>
			        </div>

							<div className="row row-margin-bottom-10">
							<div className="col-md-12">
								<label className="switch switch-3d switch-sm switch-success form-control-label">
								<input type="checkbox" className="switch-input form-check-input" 
									checked={season.hideRatingsInStandings || false} onChange={this.handleHideRatings}/>								
									<span className="switch-label"></span>
								<span className="switch-handle"></span>
								</label>
								&nbsp;&nbsp;Masquer les cotes dans les classements et la composition des équipes (ligues de 8-ball seulement)
							</div>
							</div>

							{ connectedUser.isQvneaMaster ?
								<div className="row row-margin-bottom-10">
								<div className="col-md-6">
									<label className="switch switch-3d switch-sm switch-success form-control-label">
									<input type="checkbox" className="switch-input form-check-input" 
										checked={season.enableQvneaBooksNewEntries || false} onChange={this.handleQvneaBooksNewEntries}/>								
										<span className="switch-label"></span>
									<span className="switch-handle"></span>
									</label>
									&nbsp;&nbsp;Nouvelles entrées QvneaBooks
								</div>
							</div>
							: null}

            </form>
        	</div>
        	</div>
          <hr/>

          { connectedUser.isMasterAdmin ?
					<div>
						<div className="row">
		    		<div className="col-md-12">
							<h5>Feuilles de pointage</h5>
		    		</div>
		    		</div>

						<div className="row row-margin-bottom-50">
						<div className="col-md-3">

							<div>
		  				<label htmlFor="liveScoresheets" className="small labelSmallMarginBottom">Feuilles de pointage live</label>
				  		<select className="form-control form-control-sm" type="text" id="liveScoresheets" 
				  			value={season.liveScoresheets.status} onChange={this.handleLiveScoresheetsStatusChange}>
							<option>AUCUN</option>
							<option>PRÉPARATION</option>
							<option>ACTIVÉES</option>
							</select>
							</div>

							<div className="margin-top-10">
							<label className="switch switch-3d switch-sm switch-success form-control-label">
							<input type="checkbox" className="switch-input form-check-input" 
								checked={season.liveScoresheets.adminValidationNeeded || false} onChange={this.handleLiveScoresheetsValidationChange}/>								
								<span className="switch-label"></span>
							<span className="switch-handle"></span>
							</label>
							&nbsp;&nbsp;Validation nécessaire
							</div>

						</div>

						<div className="col-md-9">

		  				<span>Formats de feuilles de pointage</span>

							<div className="row">
							<div className="col-10 d-flex">
					  		<select className="form-control form-control-sm" type="text" id="scoresheetFormatSelect" 
					  			value={this.state.selectedScoresheetFormatId}
					  			onChange={this.handleScoresheetFormatSelectChange}>

									<option key={"ssfo.nosel"} value="0"> Choisir un format de feuille de pointage </option>
									{this.state.scoresheetFormatsAll.map((sf, sfIdx) => (
										<option key={"ssfo." + sfIdx} value={sf._id}> {sf.tag} - {sf.description_fr} </option>
									))}
								</select>

								<button type="button" className="btn btn-primary btn-addScoresheetFormat" 
									onClick={this.handleAddScoresheetFormat}> +
								</button>
							</div>
							</div>

							<div className="row">
							<div className="col-10">
			  				<span>Formats sélectionnés</span>
								{this.showScoresheetFormats()}
	            </div>
							</div>

            </div>
						</div>

	          <hr/>
					</div>
					: null}

					<div className="row">
	    		<div className="col-md-12">
						<h5>Liste des Équipes</h5>
	    		</div>
	    		</div>

					<div className="row">
		    		<div className="col-md-6">
						{this.createTeamsTable()}
		    		</div>

						<div className="col-md-6">
							<div className="card">
							<div className="card-header">
								<i className="fa fa-th-large"></i>
									Ajout d'équipes
							</div>

							<div className="card-block">
							<div className="row">
	            <div className="col-md-12">
								<p>Équipes multiples: <br/>Séparer les noms d'équipe par une virgule (,)<br/>
								(exemple: Équipe 1, Équipe 2, Équipe 3, ...)</p>
								<input type="text" className="form-control" id="addNewTeamName" value={this.state.newTeamName || ''} 
									onChange={this.handleNewTeamNameChange} placeholder="Nom de l'équipe"/>
								<br/>
								<button type="button" id='addNewTeamButton' className="btn btn-primary" onClick={this.handleAddNewTeam}>
									Ajouter</button>
	            </div>
	            </div>
            	</div>
            	</div>
		        </div>
	      	</div>

					<div className="row">
					<div className="col-md-12">
						<button type="button" className="btn btn-primary" onClick={this.handleSaveClick}>
							Sauvegarder</button>
						<br/><br/>
						{this.state.msgSaved}
        	</div>
        	</div>
          <hr/>

        	{/* -------------------- MASTER ADMIN SECTION : BEGIN -------------------- */ }
          { connectedUser.isMasterAdmin ?
					<div>
	          {this.showStateloParams()}
						<hr/>
	          {this.showMontQvneaParams()}
						<hr/>

						<div className="row">
						<div className="col-md-8">
							<p><i>
								ATTENTION: la modification des paramètres QVNEA après que des scoresheets
								aient été enregistrées pourrait demander de faire certaines manipulations de DB
							</i></p>
		        </div>
		        </div>

						<div className="row">
						<div className="col-md-12">
							<button type="button" className="btn btn-primary" onClick={this.handleSaveClick}>
								Sauvegarder</button>
		      	</div>
		      	</div>

						<hr/>
	          {this.showRateSysSection()}

	          {/*this.showSeasonCumulateAction()*/}
					</div>
					: null}
        	{/* -------------------- MASTER ADMIN SECTION : END -------------------- */ }

        </div>
      );
		}
/*
	  } else {
	    return (
	      <div className="col-md-9">
	        <p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
	      </div>
	    );
		}
*/
  }

  showScoresheetFormats() {
		var scoresheetFormats = this.state.scoresheetFormatsTable;
  	return (
			<table className="table table-striped table-hover table-sm">
			<thead>
        <tr>
					<th> Format	</th>
					<th> Description </th>
					<th> Défaut </th>
					<th></th>
        </tr>
			</thead>
			<tbody>
				{scoresheetFormats.map(this.createFormatRow)}
			</tbody>
			</table>

  	)
  }

  createFormatRow(formatItem, formatIdx) {
		return (
			<tr key={'fmid.' + formatIdx}>
				<td>{formatItem.tag}</td>
				<td>{formatItem.description_fr}</td>
				<td>
					<input type="checkbox" checked={(formatItem.def || false)} 
						onChange={this.handleDefaultSsfChange.bind(this, formatIdx)}></input>
				</td>

	      <td className="text-right">
      		<span className="btn-sm2 trashIcon1" id={'remFormat.' + formatIdx} 
      			onClick={this.handleRemFormat.bind(this, formatIdx)}>
      			<i className="fa fa-trash-o"></i>
      		</span>
      	</td>
      </tr>
		)
	}

  handleScoresheetFormatSelectChange(e) {
		// console.log('SELECT format ' + e.target.value);	
		this.setState({
			selectedScoresheetFormatId: e.target.value
		});
	}

	handleAddScoresheetFormat() {
		var _this = this;
		
		let { season } = this.state;
  	var selectedScoresheetFormatId = this.state.selectedScoresheetFormatId;
		var scoresheetFormatsAll = this.state.scoresheetFormatsAll;

  	if (selectedScoresheetFormatId !== "0") {
  		var existingFormat = false;
  		season.scoresheetFormats.forEach(nsf => {
  			if (nsf._id === selectedScoresheetFormatId) {
  				existingFormat = true;
  			}
  		});

  		if (!existingFormat) {
			  season.scoresheetFormats.push({_id: selectedScoresheetFormatId, def: false});

			  // Postprocess (set default and sort)
			  season.scoresheetFormats = this.seasonScoresheetFormatsPostProcess(_this.state.scoresheetFormatsAll, season.scoresheetFormats);

				this.setState({	season: season }, 
					_this.refreshScoresheetFormatsTable(_this.state.scoresheetFormatsAll, season.scoresheetFormats)
				);
				_this.savedMsgUnset();

  		} else {
	  		alert("Format de feuille déjà inclus dans cette saison")
  		}

  	} else {
  		alert("Faire un choix de format de feuille")
  	}
	} 

	handleRemFormat(fIdx) {
		var _this = this;
		let { season } = this.state;
		season.scoresheetFormats.splice(fIdx, 1);

	  // Postprocess (set default and sort)
	  season.scoresheetFormats = this.seasonScoresheetFormatsPostProcess(_this.state.scoresheetFormatsAll, season.scoresheetFormats);
		this.setState({	season: season }, 
			_this.refreshScoresheetFormatsTable(_this.state.scoresheetFormatsAll, season.scoresheetFormats)
		);
		_this.savedMsgUnset();
	}

  showStateloParams() {
  	let { season } = this.state;
  	return (
			<div className="row row-margin-bottom-10">
			<div className="col-md-12">

				<div className="row row-margin-bottom-10">
				<div className="col-md-12">
					<h5>Paramètres Internes Statelo</h5>
					<p>(ne pas modifier)</p>
      	</div>

				<div className="col-md-3">
		  		<label htmlFor="stateloLeagueParam" className="small labelSmallMarginBottom">Configuration de classement </label>
		  		<input className="form-control form-control-sm" type="text" id="stateloLeagueParam" value={season.stateloLeagueParam || ''} onChange={this.handleLeagueParamChange}/>
        </div>

				<div className="col-md-3">
		  		<label htmlFor="formatTeamIndiv" className="small labelSmallMarginBottom">Équipes / Individuel</label>
		  		<select className="form-control form-control-sm" type="text" id="formatTeamIndiv" value={season.formatTeamIndiv} 
		  			onChange={this.handleFormatTeamIndivChange}>
					<option>{"TEAMS"}</option>
					<option>{"INDIV"}</option>
					</select>
        </div>

				<div className="col-md-3">
		  		<label htmlFor="formatMatchType" className="small labelSmallMarginBottom">Type de match</label>
		  		<select className="form-control form-control-sm" type="text" id="formatMatchType" value={season.formatMatchType} 
		  			onChange={this.handleFormatMatchTypeChange}>
					<option>{"ROUND POINTS"}</option>
					<option>{"POINTS ONLY"}</option>
					</select>
        </div>

				<div className="col-md-3">
		  		<label htmlFor="formatRoundPts" className="small labelSmallMarginBottom">Points de ronde</label>
		  		<select className="form-control form-control-sm" type="text" id="formatRoundPts" value={season.formatRoundPts} 
		  			onChange={this.handleFormatRoundPtsChange}>
					<option>{"POINTS"}</option>
					<option>{"WINS"}</option>
					</select>
        </div>		                
        </div>		                

				<div className="row row-margin-bottom-10">
				<div className="col-md-3">
		  		<label htmlFor="formatMatchPoint" className="small labelSmallMarginBottom">Point de match</label>
		  		<select className="form-control form-control-sm" type="text" id="formatMatchPoint" value={season.formatMatchPoint} 
		  			onChange={this.handleFormatMatchPointChange}>
					<option>{"MATCH POINT (POINTS)"}</option>
					<option>{"MATCH POINT (WINS)"}</option>
					<option>{"HALF MATCH POINTS"}</option>
					<option>{"NO MATCH POINT"}</option>
					</select>
        </div>

				<div className="col-md-4">
		  		<label htmlFor="seasonsGrouping" className="small labelSmallMarginBottom">Seasons grouping</label>
		  		<input className="form-control form-control-sm" type="text" id="seasonsGrouping" value={season.seasonsGrouping || ''} 
		  			onChange={this.handleSeasonsGroupingChange}/>
        </div>

				<div className="col-md-5">
		  		<label htmlFor="seasonSpecial" className="small labelSmallMarginBottom">Special Parameters</label>
		  		<input className="form-control form-control-sm" type="text" id="seasonSpecial" value={season.special || ''} 
		  			onChange={this.handleSeasonSpecialChange}/>
        </div>

        </div>

     	</div>
      </div>
  	)
  }

  showMontQvneaParams() {
  	let { season } = this.state;
  	return (
			<div className="row row-margin-bottom-10">
			<div className="col-md-12">

				<div className="row">
				<div className="col-md-12">
					<strong>Mont QVNEA</strong>
        </div>
        </div>

				<div className="row">
				<div className="col-md-3">
		  		<label htmlFor="idmqtype" className="small labelSmallMarginBottom">Type</label>
		  		<select className="form-control form-control-sm" type="text" id="idmqtype" value={season.montQvneaParams.type} 
		  			onChange={this.handleMontQvneaTypeChange}>
					<option>{""}</option>
					<option>{"METERS PER SCORESHEET"}</option>
					<option>{"METERS PER GAME"}</option>
					<option>{"METERS PER SEASON"}</option>
					</select>
        </div>
				<div className="col-md-3">
		  		<label htmlFor="idmqyears" className="small labelSmallMarginBottom">Années (y1,y2,...)</label>
		  		<input className="form-control form-control-sm" type="text" id="idmqyears" value={season.montQvneaParams.years || ''} 
		  			onChange={this.handleMontQvneaYearsChange}/>
        </div>
				<div className="col-md-3">
		  		<label htmlFor="idmqmeters" className="small labelSmallMarginBottom">Mètres</label>
		  		<input className="form-control form-control-sm" type="number" id="idmqmeters" value={season.montQvneaParams.meters || 0} 
		  			onChange={this.handleMontQvneaMetersChange}/>
        </div>
        </div>
      </div>
      </div>
  	)
  }

  showRateSysSection() {
  	return (
			<div className="row row-margin-bottom-10">
			<div className="col-md-12">

				<div className="row">
				<div className="col-md-12">
					<strong>Système de Cotation</strong>
					<p>Cliquer sur le bouton suivant pour créer un système de cotation pour la saison actuelle</p>
        </div>
        </div>

				<div className="row">
				<div className="col-md-12">
					<button type="button" className="btn btn-primary" onClick={this.handleCreateRateSysClick}>
						Créer un système de cotation</button>
      	</div>
      	</div>

      </div>
      </div>
  	)
  }

  createTeamsTable() {
  	// console.log(this.state.teams);
		var teams = this.state.teams;

    	if (teams.length === 0) {
    		return (
	    		<div>
					<h5>Équipes</h5>
					<p>Aucune équipe sélectionnée</p>
				</div>
    		);
    	} else {
	    	return (
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						Équipes
					</div>

				<div className="card-block table-responsive">
				<table className="table table-striped table-hover table-sm">
				<tbody>
	        <tr>
						<th>#</th>
						<th>Id</th>
						<th>Équipe</th>
						<th></th>
	        </tr>
					{teams.map(this.createTeamRow)}
				</tbody>
				</table>
				</div>
				</div>
			);
    }
  }

  createTeamRow(teamItem, teamIdx) {

 		return (
			<tr key={'tmid.' + teamIdx}>
				<td>{teamIdx + 1}</td>
        <td>{teamItem._id}</td>
				<td>{teamItem.name}</td>
        <td><input id={'remPlayer.' + teamIdx} type="button" onClick={this.handleRemoveTeam} value="Supprimer"/></td>
      </tr>
		)
  }

	optRatingTypes(rt, rtIdx, ratingTypes) {
		return (
			<option value={rt._id} key={'opt.rt.' + rtIdx + 1}> {rt.name} </option>
		)
	}

  // -------------------------------------------------
  // handles
	handleNewTeamNameChange(e) {
	  this.setState({
    	newTeamName: e.target.value
    });
	}

	handleSeasonNameChange(e) {
  	let { season } = this.state;
		season.name = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleSeasonsGroupingChange(e) {
  	let { season } = this.state;
		season.seasonsGrouping = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();		
	}

	handleSeasonSpecialChange(e) {
  	let { season } = this.state;
		season.special = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();		
	}

	handleStatusChange(e) {
  	let { season } = this.state;
		season.status = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleLeagueTypeChange(e) {
  	let { season } = this.state;
		season.leagueType = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleResultsTypeChange(e) {
  	let { season } = this.state;
		season.resultsType = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleNbMatchEqChange(e) {
  	let { season } = this.state;
		season.nbMatchEq = parseInt(e.target.value);
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handlePlayerCostChange(e) {
  	let { season } = this.state;
		season.playerCost = parseInt(e.target.value);
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleMembershipcardSeasonChange(e) {
  	let { season } = this.state;
		season.membershipcardSeasonId = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}
/*
	handicapTypeChange(handicapType) {
  	let { handicapType } = this.state;
		season.handicapType = handicapType;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleHandicapMaxChange(e) {
  	let { season } = this.state;
		season.handicapMax = parseInt(e.target.value);
		this.setState({ season: season });
		this.savedMsgUnset();
	}
*/
	handicapTypeChange(handicapType) {
		this.setState({ draftHandicapType: handicapType });
		this.savedMsgUnset();
	}

	handleHandicapMaxChange(e) {
		const handicapMax = parseInt(e.target.value);
		this.setState({ draftHandicapMax: handicapMax });
		this.savedMsgUnset();
	}

	handleDateStartChange(e) {
  	let { season } = this.state;
		season.dateStart = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleDateEndChange(e) {
  	let { season } = this.state;
		season.dateEnd = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleStandingTypeTeamsChange(cumulType) {
  	let { season } = this.state;
		season.standingTypeTeams = cumulType;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleStandingTypePlayersChange(cumulType) {
  	let { season } = this.state;
		season.standingTypePlayers = cumulType;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleRatingTypeChange(e) {
		let { season } = this.state;
		season.ratingTypeId = e.target.value;;
		this.setState({ season: season });
		this.savedMsgUnset();		
	}

	handleLeagueParamChange(e) {
		let { season } = this.state;
		season.stateloLeagueParam = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleFormatTeamIndivChange(e) {
		let { season } = this.state;
		season.formatTeamIndiv = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleFormatRoundPtsChange(e) {
		let { season } = this.state;
		season.formatRoundPts = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleFormatMatchPointChange(e) {
		let { season } = this.state;
		season.formatMatchPoint = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleFormatMatchTypeChange(e) {
		let { season } = this.state;
		season.formatMatchType = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleMontQvneaTypeChange(e) {
		let { season } = this.state;
		season.montQvneaParams.type = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleMontQvneaYearsChange(e) {
		let { season } = this.state;
		season.montQvneaParams.years = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleMontQvneaMetersChange(e) {
		let { season } = this.state;
		season.montQvneaParams.meters = parseInt(e.target.value);
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleHideRatings(e) {
		let { season } = this.state;
		season.hideRatingsInStandings = e.target.checked;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleQvneaBooksNewEntries(e) {
		let { season } = this.state;
		season.enableQvneaBooksNewEntries = e.target.checked;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleLiveScoresheetsStatusChange(e) {
		let { season } = this.state;
		season.liveScoresheets.status = e.target.value;
		this.setState({ season: season });
		this.savedMsgUnset();
	}
	handleLiveScoresheetsValidationChange(e) {
		let { season } = this.state;
		season.liveScoresheets.adminValidationNeeded = e.target.checked;
		this.setState({ season: season });
		this.savedMsgUnset();
	}

	handleDefaultSsfChange(fIdx, e) {
		//console.log('handleDefaultSsfChange click')
		var _this = this;
		let { season } = this.state;
		if (!season.scoresheetFormats[fIdx].def) {
			season.scoresheetFormats.map(ssf => (ssf.def = false))
			season.scoresheetFormats[fIdx].def = true;
		}

		this.setState({	season: season }, 
			_this.refreshScoresheetFormatsTable(_this.state.scoresheetFormatsAll, season.scoresheetFormats)
		);
		this.savedMsgUnset();
	}

	handleAddNewTeam(e) {
		var _this = this;
		var teams = this.state.teams;
		var newTeamName = this.state.newTeamName;
		var newTeamId = 0;

		var teamIdx = 0;
		var teamArray = [];
		
		teamArray = newTeamName.split(",");
		for(teamIdx = 0; teamIdx < teamArray.length; teamIdx++) {
			teamArray[teamIdx] = teamArray[teamIdx].trim();

			teams.push({
				_id: null,
				seasonId: _this.state.season._id,
				name: teamArray[teamIdx],
				homeSite: '',
				playersId: [],
			});
		}

		this.setState({
			teams: teams
		});

		_this.savedMsgUnset();
	}

  handleRemoveTeam(e) {
		var teamIdx = e.target.id.split(".")[1];
		var teams = this.state.teams;

		// Check if results exists for this team
		var _this = this;
		var teamId = teams[teamIdx]._id;

		// remove team still not saved
		if (teamId === null) {
			teams.splice(teamIdx, 1);
			_this.setState({
				teams: teams
			});
			_this.savedMsgUnset();

		} else {

			// Validate teamResults first
			Axios.get('/api/teams/' + teamId + '/withMatchCount').then(function(response) {
	
				var tmrCount = response.data.tmrCount;
				if (tmrCount !== 0) {
					alert('Cette équipe a déjà des résultats entrés, vous ne pouvez pas la supprimer');
				} else {
				
					var r = window.confirm("Supprimer cette équipe ?");
					if (r === true) {
						teams.splice(teamIdx, 1);
						_this.setState({
							teams: teams
						});
						_this.savedMsgUnset();
					}
				}
			});
		}
  }

  handleSaveClick = () => {
		// console.log('handleSaveClick');
		// console.log(this.state.teams);
  	// var _this = this;

  	let { season, teams } = this.state;
  	const { draftHandicapType, draftHandicapMax } = this.state;
  	season.handicapType = draftHandicapType;
  	season.handicapMax = draftHandicapMax;

		Axios.post('/api/teams/update/', {
			seasonId: season._id,
			teams: teams
		})
		.then(function(response) {
			
			// ----------------------------------------------------------
   		// Post season modifications - no need to sync with the rest
			// console.log('saving season');
			// console.log(_this.state.season);

			Axios.post('/api/seasons/' + season._id, {
				season: season,
			})
			.then(function(response) {
				//console.log(response);
				_this.props.reloadSeason();
			})
			.catch(function(error) {
				console.log(error);
			});
		})
		.catch(function(error) {
			console.log('error');
			console.log(error);
		});

		this.savedMsgSet();
  }

	/* ##################################################### */
	/* TEMPORAIRE CODE FOR AUTOMATIC CUMULATIVE CALCULATIONS */
	handleCumulClick() {
		var _this = this;
		Axios.post('/api/scoresheets/computeCumulativeResults', {
			seasonId: _this.state.season._id
		})
		.then(function(response) {
			// console.log('success');
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	/* TEMPORAIRE CODE FOR AUTOMATIC CUMULATIVE CALCULATIONS */
	/* ##################################################### */

	handleCreateRateSysClick() {
		//console.log('handleCreateRateSysClick');
		var _this = this;

		Axios.post('/api/rateSys/createRateSys/', {
			seasonId: _this.state.season._id,
		})
		.then(function(response) {
			if (response.data.msg === "OK") {
				alert("Système de cotation créé avec succès")
				_this.props.reloadSeason();
			}
			if (response.data.msg === "system is already existing") {
				alert("Système de cotation déjà existant pour cette saison")
			}
		})
		.catch(function(error) {
			console.log('error');
			console.log(error);
		});
  }

  savedMsgSet() {
		var msgSaved = "Saison sauvegardée !";
		this.setState({ msgSaved: msgSaved });
  }

  savedMsgUnset() {
		var msgSaved = "Changement non-sauvegardés";
		this.setState({ msgSaved: msgSaved });
  }

}

export default SeasonAdmin_gen;

